const fields = {
  ADDRESS: 'ADDRESS',
  APPLICANT: 'APPLICANT',
  ATTACHMENT: 'ATTACHMENT',
  BCC_MESSAGE: 'BCC_MESSAGE',
  BODY: 'BODY',
  CC_MESSAGE: 'CC_MESSAGE',
  CLAUSE: 'CLAUSE',
  CODE: 'CODE',
  CREATOR: 'CREATOR',
  DATASET: 'DATASET',
  DATE: 'DATE',
  DESCRIPTION: 'DESCRIPTION',
  DICTIONARIES: 'DICTIONARIES',
  EMAIL: 'EMAIL',
  FIELD: 'FIELD',
  HOST: 'HOST',
  ICON: 'ICON',
  IP_RANGE: 'IP_RANGE',
  JOIN: 'JOIN',
  LABEL: 'LABEL',
  LINK: 'LINK',
  LINK_DISPLAY_NAME: 'LINK_DISPLAY_NAME',
  MINIMUM_COHORT_SIZE: 'MINIMUM_COHORT_SIZE',
  NAME: 'NAME',
  NAMESPACE: 'NAMESPACE',
  OPERATOR: 'OPERATOR',
  PASSWORD: 'PASSWORD',
  PERMISSIONS: 'PERMISSIONS',
  POSITION: 'POSITION',
  PRIMARY: 'PRIMARY',
  PURPOSE: 'PURPOSE',
  RATIONALE: 'RATIONALE',
  ROLE: 'ROLE',
  SOURCE_NAME: 'SOURCE_NAME',
  SUBJECT: 'SUBJECT',
  TARGET: 'TARGET',
  TEMPLATE: 'TEMPLATE',
  TITLE: 'TITLE',
  TOKEN: 'TOKEN',
  TYPE: 'TYPE',
  URI: 'URI',
  URL: 'URL',
  USERNAME: 'USERNAME',
  VALUE: 'VALUE',
  WORKSPACE: 'WORKSPACE',
};

export const dictionaryDateTypes = {
  DATE: 'date',
  DATETIME: 'datetime',
  TIME: 'time',
};

export const dictionaryNumberTypes = {
  DECIMAL: 'decimal',
  INTEGER: 'integer',
};

export const dictionaryEntityFieldTypes = {
  ...dictionaryNumberTypes,
  TEXT: 'text',
};

export const dictionaryFieldTypes = {
  BOOL: 'boolean',
  ...dictionaryEntityFieldTypes,
  ...dictionaryDateTypes,
};

export const fieldTypeName = (type) => `dataset.dictionary.field.type.${type}`;
export const fieldTypeNameWithConstraint = (type) => `dataset.dictionary.constraint.field.type.${type}`;

export const fieldLengths = {
  micro: 16,
  mini: 32,
  tiny: 64,
  small: 256,
  medium: 500,
  large: 4096,
  big: 8192,
  huge: 16364,
  massive: 32728,
};

export const globalFieldLengths = {
  name: 250,
  sourceName: fieldLengths.medium,
  code: fieldLengths.small,
  description: fieldLengths.large,
  email: 320,
  url: 2000,
  ipRange: fieldLengths.small,
  dictionaryFieldName: fieldLengths.small,
  dictionaryFieldLabel: fieldLengths.small,
};

export const columnActive = 'active';
export const columnApproved = 'approved';
export const columnArchived = 'archived';
export const columnAssignee = 'assignee';
export const columnCategory = 'category';
export const columnCode = 'code';
export const columnCollectionDatasetCount = 'collection.dataset.count';
export const columnCollectionDatasetLastAdded = 'collection.dataset.last.added';
export const columnCollections = 'collections';
export const columnCompletedOn = 'completed.on';
export const columnConditions = 'conditions';
export const columnConsolidatedResource = 'consolidated.resource';
export const columnCreatedBy = 'created.by';
export const columnCreatedByLink = 'created.by.link';
export const columnCreatedOn = 'created.on';
export const columnDataExists = 'data.exists';
export const columnDataOwners = 'data.owners';
export const columnDataset = 'dataset';
export const columnDatasetLink = 'dataset.link';
export const columnDate = 'date';
export const columnDenied = 'denied';
export const columnDescription = 'description';
export const columnEmail = 'email';
export const columnEnabled = 'enabled';
export const columnEnforced = 'enforced';
export const columnError = 'error';
export const columnFieldLabel = 'field.label';
export const columnFieldName = 'field.name';
export const columnInfo = 'info';
export const columnIpAddress = 'ip.address';
export const columnLink = 'link';
export const columnLocation = 'location';
export const columnMultiSelect = 'multi';
export const columnName = 'name';
export const columnNameLink = 'name.link';
export const columnNameReference = 'name.reference';
export const columnPermissions = 'permissions';
export const columnProject = 'project';
export const columnPublisher = 'publisher';
export const columnReason = 'reason';
export const columnRequested = 'requested';
export const columnRequester = 'requester';
export const columnRequest = 'request';
export const columnRequestLink = 'request.link';
export const columnResource = 'resource';
export const columnReviewTools = 'review.tools';
export const columnRole = 'role';
export const columnRoleLink = 'role.link';
export const columnRoleLinkNoFilter = 'role.link.no.filter';
export const columnRowCount = 'row.count';
export const columnSearchable = 'searchable';
export const columnSecondaryResource = 'secondary.resource';
export const columnSelect = 'select';
export const columnSize = 'size';
export const columnStatus = 'status';
export const columnTarget = 'target';
export const columnTools = 'tools';
export const columnTotal = 'total';
export const columnTotalTransfers = 'total.transfers';
export const columnTransferable = 'transferable';
export const columnTransferType = 'transfer.type';
export const columnType = 'types';
export const columnUpdatedOn = 'updated.on';
export const columnUri = 'uri';
export const columnUserGroups = 'groups';
export const columnUsername = 'user.name';
export const columnUserRole = 'user.role';
export const columnUsers = 'users';
export const columnValidationDate = 'validation.date';
export const columnValidFrom = 'valid.from';
export const columnValidTo = 'valid.to';
export const columnValue = 'value';
export const columnViewing = 'viewing';
export const columnVisibility = 'visibility';
export const columnWhat = 'what';
export const columnWhen = 'when';
export const columnWorkflowName = 'workflow.name';
export const columnWorkspaceName = 'workspace.name';
export const columnWorkspaceNameLink = 'workspace.name.link';

export const orderByColumns = {
  [columnName]: 'name',
  [columnCreatedOn]: 'created_at',
  [columnUpdatedOn]: 'updated_at',
  [columnWhen]: 'when',
  [columnApproved]: 'approved_at',
  [columnUserRole]: 'roles.name',
  [columnUsername]: 'user_name',
  [columnRole]: 'role_name',
  [columnWhat]: 'what',
  [columnResource]: 'primary_name',
  [columnConsolidatedResource]: 'primary_name',
  [columnSecondaryResource]: 'secondary_name',
  [columnDataset]: 'dataset',
  [columnWorkspaceName]: 'workspace',
  [columnRequester]: 'requester_email',
  [columnTransferType]: 'transfer_type',
};

const columnsIncludes = (columns, match) => match.some((c) => columns.includes(c));

export const hasColumn = (columns, match) => (
  (Array.isArray(match) ? columnsIncludes(columns, match) : columnsIncludes(columns, [match]))
);

export default fields;
